import { useSearch } from '@tanstack/react-router'
import { useState } from 'react'
import { Icon } from '../components/icons/Icon.jsx'
import { devLogin, useAuthConfig } from '../lib/queries/session.js'
import p from './pages.module.css'

const ERRORS = {
  domain: 'That Google account is not on the DCKAP workspace. Sign in with your DCKAP account.',
  cancelled: 'Sign-in was cancelled.',
  expired: 'The sign-in took too long. Please try again.',
  state: 'The sign-in could not be verified. Please try again.',
  exchange: 'Google did not accept the sign-in. Please try again.',
  token: 'The sign-in could not be verified. Please try again.',
}

export function LoginPage() {
  const search = useSearch({ strict: false })
  const config = useAuthConfig()
  const [devError, setDevError] = useState(null)
  const next = typeof search.next === 'string' && search.next.startsWith('/') ? search.next : '/'
  const error = ERRORS[search.error] ?? (search.error ? 'Sign-in failed. Please try again.' : null)

  return (
    <main className={p.login}>
      <div className={p.loginCard}>
        <span
          style={{
            width: 42,
            height: 42,
            borderRadius: 12,
            background: 'var(--ink)',
            color: 'var(--ground)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon name="logo" size={22} strokeWidth={1.7} />
        </span>
        <h1 className={p.loginTitle}>DCKAP Hub</h1>
        <p className={p.loginText}>Sign in with your DCKAP account.</p>
        {error ? <div className={p.loginError}>{error}</div> : null}
        {config.data && !config.data.google ? (
          <button type="button" className={`btn btn-dark ${p.loginButton}`} disabled>
            Google sign-in is not configured
          </button>
        ) : (
          <a className={`btn btn-dark ${p.loginButton}`} href={`/auth/google/start?next=${encodeURIComponent(next)}`}>
            Sign in
          </a>
        )}
        {config.data?.devLogin ? (
          <button
            type="button"
            className={`btn btn-ghost ${p.loginButton}`}
            onClick={async () => {
              try {
                await devLogin()
                window.location.assign(next)
              } catch (e) {
                setDevError(e.message)
              }
            }}
          >
            Development sign-in
          </button>
        ) : null}
        {devError ? <div className={p.loginError}>{devError}</div> : null}
      </div>
    </main>
  )
}
